import { index, pgTable, uniqueIndex, uuid } from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import z from "zod";

import { clinicsTable } from "./clinicsSchema";
import { healthPlansTable } from "./healthPlansSchema";
import { customTimestamp } from "./utils/types";

export const clinicsHealthPlansTable = pgTable(
  "clinics_health_plans",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    clinicId: uuid("clinic_id")
      .references(() => clinicsTable.id, { onDelete: "cascade" })
      .notNull(),
    healthPlanId: uuid("health_plan_id")
      .references(() => healthPlansTable.id, { onDelete: "cascade" })
      .notNull(),
    createdAt: customTimestamp("created_at")
      .notNull()
      .$defaultFn(() => new Date().toISOString()),
    updatedAt: customTimestamp("updated_at")
      .notNull()
      .$defaultFn(() => new Date().toISOString())
      .$onUpdateFn(() => new Date().toISOString()),
  },
  table => [
    index("clinics_health_plans_clinic_id_index").on(table.clinicId),
    index("clinics_health_plans_health_plan_id_index").on(table.healthPlanId),
    uniqueIndex(
      "clinics_health_plans_clinic_id_health_plan_id_unique_index",
    ).on(table.clinicId, table.healthPlanId),
  ],
);

export const insertClinicsHealthPlansSchema = createInsertSchema(
  clinicsHealthPlansTable,
  {
    clinicId: z.uuid().min(1),
    healthPlanId: z.uuid().min(1),
  },
).omit({
  createdAt: true,
  updatedAt: true,
});

export type InsertClinicsHealthPlansType = z.infer<
  typeof insertClinicsHealthPlansSchema
>;
